import styled from "styled-components";
import { fontSizes, lineHeights, spacing } from "@magicbi/ui-library";
import { TagChip } from "../TagChip";

/** `.soon` pill: 20 high, 0 8 padding, 11px semibold. The default size keeps the plain TagChip look. */
export const SmallBadge = styled(TagChip)`
  box-sizing: border-box;
  flex-shrink: 0;
  white-space: nowrap;
  height: ${spacing[5]};
  padding: 0 ${spacing[2]};
  font-size: ${fontSizes["11"]};
  line-height: ${lineHeights["16"]};
  font-weight: 600;
`;
